import React from "react";
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";
import { LOGIN, ROUTER_ROLES_MAP } from "../config/constants/route";
import Dashboard from "../layouts/Dashboard";
import NoPageFound from "../layouts/NoPageFound";

import AuthLayout from "./Auth";
import ProtectedRoutes from "./Auth/PrivateRoutes";
import useRoles from "../hooks/custom-hooks/useRoles";
import { V2_ROUTES } from "../v2/routes";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<ProtectedRoutes />}>
                <Route path="/" element={<Dashboard />}>
                    {
                        Object.keys(ROUTER_ROLES_MAP).map((key) => {
                            if (useRoles(ROUTER_ROLES_MAP[key].roles)) {
                                return <Route key={key} path={ROUTER_ROLES_MAP[key].path} element={ROUTER_ROLES_MAP[key].element} />
                            }
                        })
                    }
                </Route>
                <Route path="/details" element={<>Invalid ID</>}></Route>
                {/* Ops Console v2 — nested inside ProtectedRoutes (as a sibling
                    to the legacy Dashboard and /details routes) so it inherits
                    the same login/auth gate as legacy routes. RequireRoles
                    (src/v2/routes.jsx) then applies role-based gating on top
                    of that, per-route. */}
                {V2_ROUTES}
            </Route>
            <Route
                path={LOGIN.LOGHOME}
                index
                element={<AuthLayout />}
                errorElement={<NoPageFound />}
            />
            <Route path="*" element={<NoPageFound />} />
        </>
    )
);
